module.exports = __webpack_public_path__ + "static/media/restauration.f4ed5d01.jpg";